import { AxiosResponse } from 'axios';
import api from './Api'

export const beUsedIssuedCouponById = (id: string, tossPayId: string): Promise<AxiosResponse<string, any>> => {
    return api.put(`/issued-yoga-coupon/use/${id}`, { tossPayId })
}

export const issuedCouponUse = (id: string): Promise<AxiosResponse<any, any>> => {
    return api.put(`/issued-coupon/use`, { id })
}

export const getIssuedCouponMobileById = (id: string): Promise<AxiosResponse<any, any>> => {
    return api.get(`/issued-coupon/mobile/${id}`)
}
